import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CtaButton } from "./CtaButton";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-113" data-mp="1ge8vool0cht0">
      <SectionHeading eyebrow="Frequently Asked Questions" title="Everything You Need to Know" data-id="element-114" data-mp="2e0pq9m2cwhb2" />
      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-115" data-mp="290tidbqjg5q8">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} className="overflow-hidden rounded-2xl bg-canvas" data-id="element-116" data-mp="240fem5vyzhy0" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-117" data-mp="1z2dwbn6dbmnl">
                <span className="font-display text-lg font-extrabold leading-snug text-navy" data-id="element-118" data-mp="pfuzm2q5qk9c">{f.q}</span>
                <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand text-white transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} data-id="element-119" data-mp="ueohs8ge2zfu">
                  <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-120" data-mp="6pvhjzsqi5ff" />
                </span>
              </button>
              <AnimatePresence initial={false} data-id="element-121" data-mp="bjhm14oqv305">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-122" data-mp="3szzdg5d69ypv">
                    <p className="px-5 pb-5 text-base leading-relaxed text-muted" data-id="element-123" data-mp="3nya4qwdf9x4y">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
      <div className="mt-12" data-id="element-124" data-mp="1potfgou57b7e">
        <CtaButton data-id="element-125" data-mp="1kr1d10vvg6oy">Yes! I Want the BCM Diagnostic Blueprint</CtaButton>
      </div>
    </section>;
}